module.exports = __webpack_public_path__ + "media/images/flags/16/Andorra-2aba3ce8423d8de2d883407aadabea70.png";